// Board shapes for drawing a game outside the game page (the Watch page).
// Mirrors LAYOUTS / LAYOUT_DIMS in public/game/jangle.html. H is player 1
// (pink, bottom), A is player 2 (blue, top).
const square = (rows, cols) => rows.flatMap((r) => cols.map((c) => [r, c]));
const POW = {
  PINK: [[0, 0], [0, 7], [0, 14], [30, 0], [30, 7], [30, 14]],
  GREEN: [[15, 0], [15, 7], [15, 14]],
};
const SHIELDS = [[2, 3], [2, 11], [6, 3], [6, 11], [24, 3], [24, 11], [28, 3], [28, 11]];

function tall(withShields, noGrey) {
  const spec = {};
  Object.entries(POW).forEach(([kind, cells]) => { if (!(noGrey && kind === "GREEN")) cells.forEach(([r, c]) => { spec[`${r},${c}`] = kind; }); });
  if (withShields) SHIELDS.forEach(([r, c]) => { spec[`${r},${c}`] = "SHIELD"; });
  return {
    rows: 31, cols: 15, spec,
    base: { H: square([25, 26, 27], [6, 7, 8]), A: square([3, 4, 5], [6, 7, 8]) },
  };
}

// Infinity (Jack, 2026-10-29): Fortress 2.0 with five nobody's walls across
// the middle of the centre row; the side edges are joined (wrap), drawn purple.
function infinity() {
  const spec = { ...tall(true, true).spec };
  [5, 6, 7, 8, 9].forEach((c) => { spec[`15,${c}`] = "WALL"; });
  return { ...tall(true, true), spec, wrap: true };
}

// Infinity for new games (Jack, 2026-10-29): a wall in each corner and the
// corner POW squares one square in along the back row.
function infinity2() {
  const base = infinity();
  const spec = { ...base.spec };
  [[0, 0], [0, 14], [30, 0], [30, 14]].forEach(([r, c]) => { spec[`${r},${c}`] = "WALL"; });
  [[0, 1], [0, 13], [30, 1], [30, 13]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  return { ...base, spec };
}

// Firefly (Jack, 2026-10-14): 33x15, green Pows only, nobody's walls.
function firefly() {
  const spec = {};
  [[0, 0], [0, 7], [0, 14], [8, 0], [8, 14], [16, 0], [16, 14], [24, 0], [24, 14], [32, 0], [32, 7], [32, 14]]
    .forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[4, 4], [4, 10], [13, 4], [13, 10], [16, 7], [19, 4], [19, 10], [28, 4], [28, 10]]
    .forEach(([r, c]) => { spec[`${r},${c}`] = "SHIELD"; });
  [[8, 6], [8, 7], [8, 8], [24, 6], [24, 7], [24, 8]].forEach(([r, c]) => { spec[`${r},${c}`] = "WALL"; });
  return {
    rows: 33, cols: 15, spec,
    base: { H: square([27, 28, 29], [6, 7, 8]), A: square([3, 4, 5], [6, 7, 8]) },
  };
}

// Firefly for new games (Jack, 2026-11-01): no POW squares at the ends of
// the middle row.
function firefly2() {
  const base = firefly();
  const spec = { ...base.spec };
  delete spec["16,0"]; delete spec["16,14"];
  return { ...base, spec };
}

// The Wave (Jack, 2026-10-14): Firefly's size, wedges of nobody's walls.
function theWave() {
  const spec = {};
  [[0, 0], [0, 14], [12, 0], [12, 14], [20, 0], [20, 14], [32, 0], [32, 14]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[1, 7], [4, 4], [4, 10], [16, 0], [16, 7], [16, 14], [28, 4], [28, 10], [31, 7]].forEach(([r, c]) => { spec[`${r},${c}`] = "SHIELD"; });
  [[5, 0], [5, 14], [6, 0], [6, 1], [6, 13], [6, 14], [7, 0], [7, 1], [7, 2], [7, 12], [7, 13], [7, 14], [8, 0], [8, 1], [8, 2], [8, 3], [8, 11], [8, 12], [8, 13], [8, 14], [9, 0], [9, 1], [9, 2], [9, 12], [9, 13], [9, 14], [10, 0], [10, 1], [10, 13], [10, 14], [11, 0], [11, 14], [21, 0], [21, 14], [22, 0], [22, 1], [22, 13], [22, 14], [23, 0], [23, 1], [23, 2], [23, 12], [23, 13], [23, 14], [24, 0], [24, 1], [24, 2], [24, 3], [24, 11], [24, 12], [24, 13], [24, 14], [25, 0], [25, 1], [25, 2], [25, 12], [25, 13], [25, 14], [26, 0], [26, 1], [26, 13], [26, 14], [27, 0], [27, 14]].forEach(([r, c]) => { spec[`${r},${c}`] = "WALL"; });
  return {
    rows: 33, cols: 15, spec,
    base: { H: square([27, 28, 29], [6, 7, 8]), A: square([3, 4, 5], [6, 7, 8]) },
  };
}

// Bridges (Jack, 2026-10-27): 13x27, green Pows, a bridge square behind each base.
function bridges() {
  const spec = {};
  [[0, 0], [0, 12], [13, 0], [13, 12], [26, 0], [26, 12]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[0, 6], [26, 6]].forEach(([r, c]) => { spec[`${r},${c}`] = "BRIDGE"; });
  return {
    rows: 27, cols: 13, spec,
    base: { H: square([20, 21, 22], [5, 6, 7]), A: square([4, 5, 6], [5, 6, 7]) },
  };
}

// Bridges (trial) (Jack, 2026-10-27): a river along row 13, three yellow
// squares a side that pay bridge tiles, green Pows on both banks.
function bridgesTrial() {
  const spec = {};
  for (let c = 0; c < 13; c++) spec[`13,${c}`] = "RIVER";
  [[0, 0], [0, 12], [12, 0], [12, 12], [14, 0], [14, 12], [26, 0], [26, 12]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[0, 6], [5, 0], [5, 12], [21, 0], [21, 12], [26, 6]].forEach(([r, c]) => { spec[`${r},${c}`] = "BRIDGE"; });
  return { ...bridges(), spec };
}

// Bridges (Jack, 2026-10-27): the river board with two more rows each side
// of the river (row 15) and only the four corner Pows.
function bridgesLong() {
  const spec = {};
  for (let c = 0; c < 13; c++) spec[`15,${c}`] = "RIVER";
  [[0, 0], [0, 12], [30, 0], [30, 12]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[0, 6], [5, 0], [5, 12], [25, 0], [25, 12], [30, 6]].forEach(([r, c]) => { spec[`${r},${c}`] = "BRIDGE"; });
  return {
    rows: 31, cols: 13, spec,
    base: { H: square([24, 25, 26], [5, 6, 7]), A: square([4, 5, 6], [5, 6, 7]) },
  };
}

// Bridges 2.0 (Jack, 2026-10-29): Bridges with a row of sand each side of
// the river (rows 15 and 17, river row 16), so 2 rows longer.
function bridgesSand() {
  const spec = {};
  for (let c = 0; c < 13; c++) { spec[`15,${c}`] = "SAND"; spec[`16,${c}`] = "RIVER"; spec[`17,${c}`] = "SAND"; }
  [[0, 0], [0, 12], [32, 0], [32, 12]].forEach(([r, c]) => { spec[`${r},${c}`] = "PINK"; });
  [[0, 6], [5, 0], [5, 12], [27, 0], [27, 12], [32, 6]].forEach(([r, c]) => { spec[`${r},${c}`] = "BRIDGE"; });
  return {
    rows: 33, cols: 13, spec,
    base: { H: square([26, 27, 28], [5, 6, 7]), A: square([4, 5, 6], [5, 6, 7]) },
  };
}

const SHAPES = {
  bridges: bridges(),
  bridges_trial: bridgesTrial(),
  bridges2: bridgesLong(),
  bridges3: bridgesSand(),
  boardgame5: theWave(),
  boardgame4: firefly(),
  firefly2: firefly2(),
  boardgame3: tall(false), // Classic
  boardgame2: tall(true),  // Fortress
  fortress2: tall(true, true), // Fortress 2.0: no grey Pows
  infinity: infinity(),
  infinity2: infinity2(),
  boardgame: tall(false),  // Original
  mini: {
    rows: 13, cols: 13, spec: {},
    base: { H: [4, 5, 6, 7, 8].map((c) => [12, c]), A: [4, 5, 6, 7, 8].map((c) => [0, c]) },
  },
};
const OLD = {
  rows: 20, cols: 13, spec: {},
  base: { H: [4, 5, 6, 7, 8].map((c) => [19, c]), A: [4, 5, 6, 7, 8].map((c) => [0, c]) },
};

export function boardShape(layout) {
  return SHAPES[layout] || OLD;
}

export const LAYOUT_NAMES = {
  boardgame3: "Classic", boardgame2: "Fortress", fortress2: "Fortress 2.0", infinity: "Infinity (old)", infinity2: "Infinity", boardgame4: "Firefly (old)", firefly2: "Firefly", boardgame5: "The Wave", bridges: "Bridges (old)", bridges_trial: "Bridges (short)", bridges2: "Bridges", bridges3: "Bridges 2.0", boardgame: "Original",
  classic: "Old Classic", fortress: "Classic Fortress", gauntlet: "Gauntlet",
  open_field: "Open Field", mini: "Mini",
};
